import { cn } from 'cn';
import { BaseButton } from '../../Button';
import Icon, { type IconType } from '../../Icon';

interface PaginationNavigationButtonProps {
  disabled: boolean;
  icon: IconType;
  label: string;
  onClick: (() => void) | undefined;
  onMouseOver: (() => void) | undefined;
}

export function PaginationNavigationButton({
  disabled,
  icon,
  label,
  onClick,
  onMouseOver,
}: PaginationNavigationButtonProps) {
  return (
    <li>
      <BaseButton
        aria-label={label}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
        onMouseOver={disabled ? undefined : onMouseOver}
        className={cn(
          'typ-button-xs enabled:hover:bg-neutral-10 enabled:active:bg-blue-10 rounded enabled:active:text-blue-100',
          'flex size-8 items-center justify-center',
          disabled ? 'text-neutral-60' : 'text-neutral-110',
        )}
      >
        <Icon type={icon} size="small" />
      </BaseButton>
    </li>
  );
}
